import React from 'react';
import { BaseLayout } from './BaseLayout';
import { layoutConfigs } from './layoutConfigs';
import { IncorporadorSidebar } from './IncorporadorSidebar';

interface IncorporadorLayoutProps {
  children: React.ReactNode;
}

export const IncorporadorLayout: React.FC<IncorporadorLayoutProps> = ({ children }) => {
  return (
    <BaseLayout
      sidebar={<IncorporadorSidebar />}
      config={layoutConfigs.incorporador}
    >
      {children}
    </BaseLayout>
  );
};

export default IncorporadorLayout;
